// extracted by mini-css-extract-plugin
module.exports = {"description":"dece2e673c--description--jyOvh"};